// extracted by mini-css-extract-plugin
module.exports = {"Container":"History_Container__1zG0N","TitleContainer":"History_TitleContainer__2HgcO","Title":"History_Title__2O4xB","Icon":"History_Icon__3bb9M","Text":"History_Text__3gK5j"};